import { Divider } from "@tokenterminal/core/ui/layout/divider/Divider"
import Image from "next/image"
import { twMerge } from "tailwind-merge"
import { slides } from "../../../constants/content"
import ImagePane from "../../home/hero/ImagePane"

const tableData = [
  {
    groupName: "Income statement",
    rows: [
      ["Fees", "$94.64m", "$62.82m", "$103.72m", "$142.28m"],
      ["(Supply-side fees)", "$38.30m", "$27.96m", "$35.51m", "$37.28m"],
      ["Revenue", "$56.33m", "$34.85m", "$68.22m", "$105.01m"],
      ["(Expenses)", "$265.95m", "$217.14m", "$197.39m", "$208.47m"],
    ].map(([label, value1, value2, value3]) => [
      <span key={label} className="text-sm">
        {label}
      </span>,
      <span key={value1} className="text-sm" style={{ textAlign: "right" }}>
        {value1}
      </span>,
      <span
        key={value2}
        className="text-sm"
        style={{ textAlign: "right", fontFamily: "var(--font-geist-mono)" }}
      >
        {value2}
      </span>,
      <span
        key={value2}
        className="text-sm"
        style={{ textAlign: "right", fontFamily: "var(--font-geist-mono)" }}
      >
        {value2}
      </span>,
      <span
        key={value3}
        className="text-sm"
        style={{ textAlign: "right", fontFamily: "var(--font-geist-mono)" }}
      >
        {value3}
      </span>,
    ]),
  },
]

function FinancialStatement() {
  // Understand slide is at index 0
  const understandSlideIndex = 0
  const understandSlide = slides[understandSlideIndex]

  return (
    <div
      className={twMerge(
        "rounded-[25px]",
        "shadow-[0_0_20px_10px_--theme(--color-neutral-900/0.15)] md:shadow-[0_0_40px_10px_--theme(--color-neutral-900/0.15)] lg:shadow-[0_0_150px_20px_--theme(--color-neutral-900/0.15)]",
        "dark:shadow-[0_0_20px_10px_#0d0d0d] dark:md:shadow-[0_0_40px_10px_#0d0d0d] dark:wlg:shadow-[0_0_150px_20px_#0d0d0d]",
      )}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <ImagePane
        currentSlideIndex={understandSlideIndex}
        containerStyle={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: understandSlide.accentColor,
        }}
        imageStyle={{
          backgroundPosition: "top -100px left -335px",
        }}
      />
      <div
        className="flex flex-col gap-4 bg-bg-surface"
        style={{
          borderRadius: "15px",
          position: "absolute",
          left: "16px",
          top: "16px",
          zIndex: 1,
          padding: "24px",
          width: "800px",
          height: "900px",
        }}
      >
        <div className="flex items-start gap-5">
          <Image
            alt="Eth logo"
            height={32}
            width={32}
            src="https://static1.tokenterminal.com/ethereum/logo.png"
            style={{
              borderRadius: "50%",
            }}
          />
          <div className="flex flex-col gap-0 items-start">
            <div className="text-lg font-medium">Financial Statement</div>
            <div className="text-sm text-fg-secondary">Ethereum</div>
          </div>
        </div>
        <Divider />
        {tableData.map((group) => (
          <table
            key={group.groupName}
            style={{
              textAlign: "left",
              width: "550px",
            }}
          >
            <thead>
              <tr>
                <th>
                  <div className="text-sm text-fg-secondary font-medium pb-2">
                    {group.groupName}
                  </div>
                </th>
                <th>
                  <div className="text-sm text-fg-secondary font-medium pb-2">Jul 2024</div>
                </th>
                <th>
                  <div className="text-sm text-fg-secondary font-medium pb-2">Aug 2024</div>
                </th>
                <th>
                  <div className="text-sm text-fg-secondary font-medium pb-2">Sep 2024</div>
                </th>
                <th>
                  <div className="text-sm text-fg-secondary font-medium pb-2">Oct 2024</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {group.rows.map((row, index) => (
                <tr key={index}>
                  <td style={{ padding: "6px 0" }}>{row[0]}</td>
                  <td style={{ padding: "6px 0" }}>{row[1]}</td>
                  <td style={{ padding: "6px 0" }}>{row[2]}</td>
                  <td style={{ padding: "6px 0" }}>{row[3]}</td>
                  <td style={{ padding: "6px 0" }}>{row[4]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </div>
    </div>
  )
}

export default FinancialStatement
